import { $api } from '../../global';

export const getUniversityById = (univerId?: string | string[]) => async () => {
  const { data } = await $api.get('/university-info', {
    params: { univer_id: univerId }
  });

  return data;
};
